import { type CategoryDTO } from 'ecosystem'
import { createContext } from 'ui/lib/react-utils'

export interface SlideOutCategoriesDesktopContextState {
  customColors?: {
    // first column bg color
    columnBg: string
    itemBg: string
    itemBgActive: string
  }
  currentTopCategory: CategoryDTO | null
  paths: {
    categories: string
  }
}

export const [SlideOutCategoriesDesktopProvider, useSlideOutCategoriesDesktop] =
  createContext<SlideOutCategoriesDesktopContextState>({
    name: 'MenuMultiColumnSlideOutCategoriesDesktop'
  })
